

import { addSourcesApi } from "apis/repairing.api";
import FormController from "pages/layout/FormController";
import { memo, useMemo, } from "react";



const RepairingSourceFormController = function () {


    const fieldSchema = useMemo(
        () => [
            {
                title: "Name",
                placeholder: "Enter name",
                key: "name",
                type: "text",
                required: true,
                default: "",
            },
            {
                title: "Priority",
                placeholder: "Enter priority",
                key: "priority",
                type: "number",
                required: true,
                default: "",
            }
        ],
        []
    );
    return <FormController

        routeForRedirect="/repairing-source/"
        title=" Repairing problems"
        inputFiedsSchema={fieldSchema}
        addFun={addSourcesApi}
        getByIdFun={() => { }}
        updateFun={() => { }}

    />
};
export default memo(RepairingSourceFormController);
